import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { MenuLayout } from '../../themes/SwitchTheme';
import { SpinWheel } from './index';
import { AdventCalendar } from './AdventCalendar';
import { MemoryGame } from './MemoryGame';
import { ScratchCard } from './ScratchCard';

const GameZonePage: React.FC = () => {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState<'spinwheel' | 'advent' | 'memory' | 'scratch'>('spinwheel');

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tab = params.get('tab');
    if (tab === 'memory') {
      setActiveTab('memory');
    } else if (tab === 'scratch') {
      setActiveTab('scratch');
    }
  }, [location]);

  return (
    <MenuLayout>
      <div style={{ borderBottom: '1px solid #ddd', marginBottom: '20px' }}>
        <nav style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          gap: '60px',
          paddingBottom: '20px'
        }}>
          <button
            onClick={() => setActiveTab('spinwheel')}
            style={{
              background: 'none',
              border: 'none',
              fontSize: '16px',
              fontWeight: activeTab === 'spinwheel' ? '700' : '400',
              color: '#191919',
              textTransform: 'uppercase',
              letterSpacing: '1px',
              cursor: 'pointer',
              padding: '10px 0',
              borderBottom: activeTab === 'spinwheel' ? '2px solid #191919' : '2px solid transparent',
              transition: 'all 0.3s ease'
            }}
          >
            Glücksrad
          </button>
          <button
            onClick={() => setActiveTab('advent')}
            style={{
              background: 'none',
              border: 'none',
              fontSize: '16px',
              fontWeight: activeTab === 'advent' ? '700' : '400',
              color: '#191919',
              textTransform: 'uppercase',
              letterSpacing: '1px',
              cursor: 'pointer',
              padding: '10px 0',
              borderBottom: activeTab === 'advent' ? '2px solid #191919' : '2px solid transparent',
              transition: 'all 0.3s ease'
            }}
          >
            Adventskalender
          </button>
          <button
            onClick={() => setActiveTab('memory')}
            style={{
              background: 'none',
              border: 'none',
              fontSize: '16px',
              fontWeight: activeTab === 'memory' ? '700' : '400',
              color: '#191919',
              textTransform: 'uppercase',
              letterSpacing: '1px',
              cursor: 'pointer',
              padding: '10px 0',
              borderBottom: activeTab === 'memory' ? '2px solid #191919' : '2px solid transparent',
              transition: 'all 0.3s ease'
            }}
          >
            Memory
          </button>
          <button
            onClick={() => setActiveTab('scratch')}
            style={{
              background: 'none',
              border: 'none',
              fontSize: '16px',
              fontWeight: activeTab === 'scratch' ? '700' : '400',
              color: '#191919',
              textTransform: 'uppercase',
              letterSpacing: '1px',
              cursor: 'pointer',
              padding: '10px 0',
              borderBottom: activeTab === 'scratch' ? '2px solid #191919' : '2px solid transparent',
              transition: 'all 0.3s ease'
            }}
          >
            Rubbel-Los
          </button>
        </nav>
      </div>
      <div style={{ textAlign: 'center' }}>
        {activeTab === 'spinwheel' && <SpinWheel />}
        {activeTab === 'advent' && <AdventCalendar />}
        {activeTab === 'memory' && <MemoryGame />}
        {activeTab === 'scratch' && <ScratchCard />}
      </div>
    </MenuLayout>
  );
};

export default GameZonePage;